import React, { useEffect, useRef,useState,useMemo } from 'react';
import {Chart} from 'chart.js/auto';
import axios from 'axios';
import moment from 'moment';

const chunkSize = 1000

const Myara = ({youWantData}) => {
    const chartRef = useRef(null);
    const chartPartite = useRef(null);
    const [myLabel, setMyLabel] = useState([]);
    const [myData, setMyData] = useState([]);
    const [myPartite, setMyPartite] = useState({});
    const [headerTabDenunce, setHeaderTabDenunce] = useState([]);
    const [bodyTabDenunce, setBodyTabDenunce] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [isProduction, setIsProduction] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [dbName, setDbName] = useState({produzione:'myara1857_prod_',sviluppo:'myara1857_dev_'});
    const [responseUpdateYear, setResponseUpdateYear] = useState('')
    const [logContent, setLogContent] = useState()
    const [filteredContent, setFilteredContent] = useState()
    const [checkedError, setCheckedError] = useState(false)
    const [typeOfFilter,setTypeOfFilter] = useState()
    const [filterWord,setFilterWord] = useState()



    const giveMeData = () => {
        axios.get('https://api-prod10.myara1857.it/api/v2/dashboard/givemeDashboard')
        .then((res) => {
            //console.log(res.data.data[1])
            let labelTmp = []
            let dataTmp = []
            setMyPartite({...res.data.data[1]})
            setHeaderTabDenunce([...res.data.data[3]])
            setBodyTabDenunce([...res.data.data[4]])
            res.data.data[0].forEach(element => {
                //console.log(element)
                labelTmp.push(element.status === "start" ? 1 : 0)
                // trasformo la data in un formato leggibile
                //let data = new Date(element.created_at)
                // trasformo con moment la data in giorno mese
                let data = moment(element.created_at).format('DD/MM')
                data = data.toString()
                dataTmp.push(data)
            });
            setMyLabel([...labelTmp])
            setMyData([...dataTmp])

        })
        .catch((err) => {
            console.log(err)
        })
    }


    useEffect(() => {
      givMeLog()
    },[])
    const givMeLog = async () => {
      let resp = await axios.get('https://api-prod10.myara1857.it/api/v2/dashboard/send_log_file')
      parseLog(resp.data.message);
    }

    useEffect(() => {
        if(youWantData){
            giveMeData()
        }
    }, [youWantData])

    useEffect(() => {
        if(myLabel.length > 0 && myData.length > 0){
        const myChartRef = chartRef.current.getContext('2d');
        // setto la larghezza del grafico
        myChartRef.canvas.parentNode.style.width = '60vw';

        new Chart(myChartRef, {
            type: 'line',
            
            data: {
                // personalizza le label 0 start e 1 complete
                labels: myData,
                
                datasets: [
                    {
                        label: 'CARICAMENTO CSV',
                        data: myLabel,
                        backgroundColor: 'rgba(255, 99, 132, 0.2)',
                        borderColor: 'rgba(255, 99, 132, 1)',
                        borderWidth: 1,
                        tension: 1,
                    },
                ],
            },
            options: {
                responsive: true,
                legend: {
                  position: 'bottom',
                },
                hover: {
                  mode: 'label'
                },
                scales: {
                  x: {
                    display: true,
                    scaleLabel: {
                      display: true,
                      labelString: 'Month'
                    }
                  },
                  y: {
                    display: true,
                    scaleLabel: {
                      display: true,
                      labelString: 'Value'
                    },
                    ticks: {
                      min: 0,
                      max: 5,
                      stepSize: 1,
                      suggestedMin: 0.5,
                      suggestedMax: 5.5,
                      callback: function(label, index, labels) {
                        switch (label) {
                          case 0:
                            return 'COMPLETE';
                          case 1:
                            return 'START';
                          default:
                            return '';
                        }
                      }
                    },
                    gridLines: {
                      display: false
                    }
                  }
                }
              }
            

        });
    }
    }, [myLabel,myData]);

    // creo un grafico a barre per le partite

    useEffect(() => {

        if(myPartite.partite && myPartite.partite_totali ){

            const myChartRef = chartPartite.current.getContext('2d');
            // setto la larghezza del grafico
            myChartRef.canvas.parentNode.style.width = '60vw';

            new Chart(myChartRef, {
                type: 'bar',
                
                data: {
                    // personalizza le label 0 start e 1 complete
                    labels: ['partite  con coordinate','partite totali'],
                    
                    datasets: [
                        {
                            label: 'COORDINATE PARTITE',
                            data: [myPartite.partite,myPartite.partite_totali],
                            backgroundColor: 'rgba(255, 99, 132, 0.2)',
                            borderColor: 'rgba(255, 99, 132, 1)',
                            borderWidth: 1,
                            tension: 1,
                        },
                    ],
                },    

            });
        }
        }
        , [myPartite])

        const setAmbiente = (e) => {
          //console.log(e.target.checked)
          //console.log(e.target.value)
          
          if(e.target.checked){
            setIsProduction(e.target.value)
          } else {
            setIsProduction(false)
          }
        }


        const updateYear = () => {
          // Impostiamo l'intestazione Content-Type su application/json
          const headers = new Headers();
          headers.append("Content-Type", "application/json");
        
          // Creiamo il corpo della richiesta JSON
          const body = JSON.stringify({
            email: email,
            password: password,
            db_name: dbName[isProduction] + year
          });

          const url = isProduction === 'produzione' ? 'https://api-prod10.myara1857.it/api/v2/newyear/update_year' : 'https://api-dev10.myara1857.it/api/v2/newyear/update_year'
        
          // Effettuiamo la richiesta
          fetch(url, {
            method: "POST",
            headers: headers,
            body: body
          })
          .then(response => response.text())
          .then(result => setResponseUpdateYear(result.split('\n')))
          .catch(error => console.log('Errore:', error));
        }

        const sendEmail = () => {
          const headers = new Headers();
          headers.append("Content-Type", "application/json");

          const url = isProduction === 'produzione' ? 'https://api-prod10.myara1857.it/api/v2/dashboard/compare_users_hail_ara' : 'https://api-dev10.myara1857.it/api/v2/dashboard/compare_users_hail_ara'

            // Effettuiamo la richiesta
            fetch(url, {
              method: "GET",
              headers: headers,
            })
            .then(response => response.text())
            .then(result => alert(result))
            .catch(error => console.log('Errore:', error));
        }


        const parseLog = (logContent) => {
          const logEntries = logContent.trim().split("\n");
          const parsedLogs = [];
      
          logEntries.forEach(entry => {
              const regex = /\[(?<date>\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})\] (?<level>[\w\.]+): (?<message>[^{]+) (?<details>.*)/;
              const match = entry.match(regex);
      
              if (match) {
                  const { date, level, message, details } = match.groups;
      
                  let httpDetails;
                  try {
                      httpDetails = JSON.parse(details);
                  } catch (e) {
                      httpDetails = null;
                  }
      
                  if(httpDetails) {
                    parsedLogs.push({
                        date,
                        level,
                        message: message.trim(),
                        details: httpDetails
                    });
                }
              }
          });
      

          setLogContent(parsedLogs)
          setFilteredContent(parsedLogs)
      }



    const [searchQuery, setSearchQuery] = useState('');

    const processedItems = useMemo(() => {
      return filterFunction(logContent, searchQuery, typeOfFilter, checkedError);
    }, [searchQuery, typeOfFilter, checkedError, logContent]);
    
    const logList = (
      <div className="log-inspector-card">
        <div className="log-inspector-header">
          <div className="log-title-area">
            <div className="log-title">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line></svg>
              <span>Console Log di Sistema</span>
            </div>
            <span className="log-counter">
              {processedItems ? `${processedItems.length} di ${logContent ? logContent.length : 0} log` : '0 log'}
            </span>
          </div>

          <div className="log-controls-row">
            {/* Free-text search input */}
            <div className="log-search-container">
              <svg className="log-search-icon" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
              <input 
                type="text" 
                className="log-search-input"
                placeholder="Filtro libero (search IP, URI, status, data, risposta...)"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              {searchQuery && (
                <button className="log-clear-btn" onClick={() => setSearchQuery('')} title="Pulisci ricerca">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                </button>
              )}
            </div>

            {/* Quick Filter Chips */}
            <div className="log-filter-chips">
              <button 
                className={`filter-chip ${!checkedError ? 'active' : ''}`}
                onClick={() => setCheckedError(false)}
              >
                Tutti i Log
              </button>
              <button 
                className={`filter-chip err ${checkedError ? 'active err' : ''}`}
                onClick={() => setCheckedError(!checkedError)}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
                Solo Errori
              </button>
            </div>
          </div>
        </div>

        <div className="log-inspector-body">
          {!processedItems || processedItems.length === 0 ? (
            <div className="empty-log-state">
              Nessun log corrisponde ai criteri di ricerca forniti.
            </div>
          ) : (
            processedItems.map((el, ind) => {
              const status = el.details?.status_code || 200;
              const isSuccess = status >= 200 && status < 300;
              return (
                <div key={ind} className="log-entry-card">
                  <div className="log-entry-top">
                    <div className="log-meta-left">
                      <span className={`status-badge ${isSuccess ? 'status-2xx' : 'status-4xx'}`}>
                        {status} {isSuccess ? 'OK' : 'ERR'}
                      </span>
                      <span className="log-date-tag">📅 {el.date}</span>
                      {el.details?.ip && <span className="log-ip-badge">🌐 IP: {el.details.ip}</span>}
                    </div>
                  </div>

                  <div className="log-uri-path">
                    🔗 {el.details?.uri ? el.details.uri.split('?')[0] : '/'}
                  </div>

                  {el.details?.response && (
                    <div className="log-response-text">
                      {typeof el.details.response === 'object' 
                        ? JSON.stringify(el.details.response, null, 2)
                        : el.details.response}
                    </div>
                  )}
                </div>
              );
            })
          )}
        </div>
      </div>
    );

    return (
        <div className='chart-container'>
            <canvas id="myChart" ref={chartRef} className='canva-chart' ></canvas>
            <canvas id="myChartPartite" ref={chartPartite} className='canva-chart'></canvas>

            {logList}

            <div className='update-year'>
              <h3 className="dash-section-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 12a9 9 0 0 1-9 9m9-9a9 9 0 0 0-9-9m9 9H3m9 9a9 9 0 0 1-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9"></path></svg>
                Aggiorna Anno Sotto-Sistema
              </h3>

              <div className="env-selector-row">
                <label className="custom-env-toggle">
                  <input type="checkbox" id="isProduction" value="produzione" onClick={setAmbiente} checked={isProduction === 'produzione'} readOnly />
                  <span>Produzione</span>
                </label>
                <label className="custom-env-toggle">
                  <input type="checkbox" id="isDev" value="sviluppo" onClick={setAmbiente} checked={isProduction === 'sviluppo'} readOnly />
                  <span>Sviluppo</span>
                </label>
              </div>

              <div className="dash-form-grid">
                <div className="dash-field-group">
                  <label>Admin Email</label>
                  <input type='email' className="dash-input-text" placeholder="admin@myara1857.it" onChange={(e) => setEmail(e.target.value)} />
                </div>
                <div className="dash-field-group">
                  <label>Admin Password</label>
                  <input type='password' className="dash-input-text" placeholder="••••••••••••" onChange={(e) => setPassword(e.target.value)} />
                </div>
                <div className="dash-field-group">
                  <label>Nome Database Target</label>
                  <input type='text' className="dash-input-text" disabled value={dbName[isProduction] ? dbName[isProduction] + year : 'Seleziona ambiente'} />
                </div>
              </div>

              <button onClick={updateYear} className="btn-action primary">
                Aggiorna Anno DB
              </button>
              
              {responseUpdateYear && (
                <div className='resp_update_year toast-success' style={{ marginTop: '1rem' }}>
                  {responseUpdateYear.map((el, i) => <span key={i}>{el} </span>)}
                </div>
              )}
            </div>

            <div className="compare-users-hail-ara" style={{ marginTop: '2rem' }}>
              <h3 className="dash-section-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
                Confronta Utenti Hail ARA
              </h3>
              <div className="env-selector-row">
                <label className="custom-env-toggle">
                  <input type="checkbox" value="produzione" onClick={setAmbiente} checked={isProduction === 'produzione'} readOnly />
                  <span>Produzione</span>
                </label>
                <label className="custom-env-toggle">
                  <input type="checkbox" value="sviluppo" onClick={setAmbiente} checked={isProduction === 'sviluppo'} readOnly />
                  <span>Sviluppo</span>
                </label>
              </div>
              <button onClick={sendEmail} className="btn-action secondary">
                Invia Email Confronto Utenti
              </button>
            </div>

            {headerTabDenunce.length > 0 && bodyTabDenunce.length > 0 && (
              <div className="progetti-table-card" style={{ marginTop: '2.5rem' }}>
                <h3 className="dash-section-title" style={{ padding: '1rem 1.5rem 0 1.5rem' }}>Denunce Eliminate</h3>
                <div className="progetti-table-wrapper">
                  <table className='progetti-table'>
                    <thead>
                      <tr>
                        {headerTabDenunce.map((item, index) => {
                          if (![0, 10, 11, 12, 15, 17, 19].includes(index)) {
                            return <th key={index}>{item}</th>;
                          }
                          return null;
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {bodyTabDenunce.map((row, rIdx) => (
                        <tr key={rIdx}>
                          {row.map((val, cIdx) => {
                            if (![0, 10, 11, 12, 15, 17, 19].includes(cIdx)) {
                              return <td key={cIdx}>{val}</td>;
                            }
                            return null;
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
        </div>
    );
};

const filterFunction = (items, search, type, checked) => {
  if (!items || !Array.isArray(items)) return [];

  let result = [...items];

  // Apply Free-text Search
  if (search && search.trim()) {
    const q = search.toLowerCase().trim();
    result = result.filter(item => {
      const dateMatch = item.date && item.date.toLowerCase().includes(q);
      const levelMatch = item.level && item.level.toLowerCase().includes(q);
      const msgMatch = item.message && item.message.toLowerCase().includes(q);
      const ipMatch = item.details?.ip && item.details.ip.toLowerCase().includes(q);
      const uriMatch = item.details?.uri && item.details.uri.toLowerCase().includes(q);
      const statusMatch = item.details?.status_code && item.details.status_code.toString().includes(q);
      const respMatch = item.details?.response && (
        typeof item.details.response === 'string'
          ? item.details.response.toLowerCase().includes(q)
          : JSON.stringify(item.details.response).toLowerCase().includes(q)
      );

      return dateMatch || levelMatch || msgMatch || ipMatch || uriMatch || statusMatch || respMatch;
    });
  }

  // Apply "Only Errors" toggle if checked
  if (checked) {
    result = result.filter(x => x.details?.status_code !== 200);
  }

  return result;
};

export default Myara;
